import { Redirect } from 'react-router-dom'
import Order from 'state/models/Order'

const defaultStatus = Object.values(Order.STATUS)[0]
export default function RouteNotFound({ location }) {
	if (location?.pathname != '/') {
		console.warn('404?', location) //TODO: issue a 404 alert
	}
	return <Redirect to={`/${defaultStatus}`}/>
}
